import { render, staticRenderFns } from "./About2.vue?vue&type=template&id=4b90ec5c&"
import script from "./About2.vue?vue&type=script&lang=js&"
export * from "./About2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports